(function () {
  const CONFIG_SELECTOR = "[data-collection-load-more-config]";
  const TRIGGER_SELECTOR = "[data-collection-load-more-trigger]";
  const WRAPPER_SELECTOR = "[data-collection-load-more]";
  const GRID_SELECTOR = "[data-collection-grid]";
  const STATUS_SELECTOR = "[data-collection-load-more-status]";
  const LABEL_SELECTOR = "[data-collection-load-more-label]";
  const BUFFER_SELECTOR = "[data-row-buffer]";
  const GRID_COLUMNS = 4;

  const configEl = document.querySelector(CONFIG_SELECTOR);
  const grid = document.querySelector(GRID_SELECTOR);
  if (!configEl || !grid) return;

  const sectionId = configEl.getAttribute("data-section-id");
  const loadingText = configEl.getAttribute("data-loading-text");
  const loadMoreText = configEl.getAttribute("data-load-more-text");
  const loadedAnnouncement = configEl.getAttribute("data-loaded-announcement");

  const buildFetchUrl = (nextUrl) => {
    const url = new URL(nextUrl, window.location.origin);
    url.searchParams.set("section_id", sectionId);
    return url.toString();
  };

  const setLoadingState = (trigger, isLoading) => {
    const label = trigger.querySelector(LABEL_SELECTOR);
    trigger.setAttribute("aria-disabled", String(isLoading));
    trigger.classList.toggle("pointer-events-none", isLoading);
    trigger.classList.toggle("opacity-60", isLoading);
    if (label) label.textContent = isLoading ? loadingText : loadMoreText;
  };

  const announceLoaded = () => {
    const statusEl = document.querySelector(STATUS_SELECTOR);
    if (statusEl) statusEl.textContent = loadedAnnouncement;
  };

  const updateHistory = (nextUrl) => {
    if (window.history && window.history.pushState) {
      window.history.pushState({}, "", nextUrl);
    }
  };

  // Reveals any products that were held back (by Liquid or a previous round
  // of this same function) because they didn't yet complete a full row.
  const revealBufferedCards = () => {
    grid.querySelectorAll(BUFFER_SELECTOR).forEach((card) => {
      card.classList.remove("hidden");
      card.removeAttribute("data-row-buffer");
    });
  };

  // Holds back whichever trailing products don't complete a full row, so
  // they can be revealed alongside the next batch instead of being lost.
  const bufferTrailingRow = () => {
    const remainder = grid.children.length % GRID_COLUMNS;
    if (remainder === 0) return;

    Array.from(grid.children)
      .slice(-remainder)
      .forEach((card) => {
        card.classList.add("hidden");
        card.setAttribute("data-row-buffer", "");
      });
  };

  const appendProducts = (newGrid) => {
    Array.from(newGrid.children).forEach((card) => grid.appendChild(card));
  };

  const updateOrRemoveWrapper = (wrapper, trigger, newWrapper) => {
    if (!newWrapper) {
      wrapper.remove();
      return;
    }

    const newNextUrl = newWrapper.getAttribute("data-next-url");
    const newTrigger = newWrapper.querySelector(TRIGGER_SELECTOR);

    wrapper.setAttribute("data-next-url", newNextUrl);
    if (newTrigger)
      trigger.setAttribute("href", newTrigger.getAttribute("href"));
  };

  const handleLoadMore = (event) => {
    event.preventDefault();

    const trigger = event.currentTarget;
    const wrapper = trigger.closest(WRAPPER_SELECTOR);
    const nextUrl = wrapper ? wrapper.getAttribute("data-next-url") : null;

    if (!wrapper || !nextUrl) return;

    setLoadingState(trigger, true);

    fetch(buildFetchUrl(nextUrl))
      .then((response) => {
        if (!response.ok) throw new Error("Failed to load more products");
        return response.text();
      })
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const newGrid = doc.querySelector(GRID_SELECTOR);
        const newWrapper = doc.querySelector(WRAPPER_SELECTOR);

        // Reveal last round's held-back products now that more are arriving,
        // append the newly fetched ones, then hold back this round's
        // trailing remainder — unless this was the final page, in which
        // case there's nothing left to wait for.
        revealBufferedCards();
        if (newGrid) appendProducts(newGrid);
        if (newWrapper) bufferTrailingRow();

        updateOrRemoveWrapper(wrapper, trigger, newWrapper);

        setLoadingState(trigger, false);
        updateHistory(nextUrl);
        announceLoaded();
      })
      .catch(() => {
        setLoadingState(trigger, false);
        window.location.href = nextUrl;
      });
  };

  // If page 1 is also the last page, nothing more will ever arrive to
  // complete the row — reveal any buffered products immediately.
  if (!document.querySelector(WRAPPER_SELECTOR)) {
    revealBufferedCards();
  }

  document.querySelectorAll(TRIGGER_SELECTOR).forEach((trigger) => {
    trigger.addEventListener("click", handleLoadMore);
  });
})();
